import { render, staticRenderFns } from "./privateUpload.vue?vue&type=template&id=0db2e95f"
import script from "./privateUpload.vue?vue&type=script&lang=js"
export * from "./privateUpload.vue?vue&type=script&lang=js"
import style0 from "./privateUpload.vue?vue&type=style&index=0&id=0db2e95f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports